import { RoleBundle, TClientHubFiltersPayload } from "services";
import { RoleBundleResponse } from "services/clienthub/clienthub.types";

export const getPermissionsByType = (data: RoleBundleResponse, type: "LD" | "PACE") =>
    data.bundles?.filter((permission) => permission.name.includes(type)) || [];

export const normalizeHubManagementFilters = (
    filters: Partial<TClientHubFiltersPayload>,
    ldPermissionsData: RoleBundle[],
    pacePermissionsData: RoleBundle[]
) => {
    const isLDPermissionDefault = filters.filter_roles_ld?.some((val) => val === "all");
    const isPACEPermissionDefault = filters.filter_roles_pace?.some((val) => val === "all");

    const result = {
        ...(filters.filter_name ? { filter_name: filters.filter_name } : {}),
        ...(filters.order_by ? { order_by: filters.order_by } : {}),
        ...(isLDPermissionDefault
            ? {}
            : {
                  filter_roles_ld: filters.filter_roles_ld?.map(
                      (id) => ldPermissionsData.find((p) => p.name === id)?.name || ""
                  ),
              }),
        ...(isPACEPermissionDefault
            ? {}
            : {
                  filter_roles_pace: filters.filter_roles_pace?.map(
                      (id) => pacePermissionsData.find((p) => p.name === id)?.name || ""
                  ),
              }),
    };

    return result;
};
